export default __webpack_public_path__ + "static/us-enterprise-work-better-78108dc259ba9a943b7a1933962b8d91.mp4";